import type { ReactNode } from 'react';
import styled from '@emotion/styled';
import type { IconName } from '@hotjar/hotsauce';
import { Icon, tokens, Text } from '@hotjar/hotsauce';
import { css } from '@emotion/react';

const Container = styled('div')`
  padding: ${tokens.spacer.x3} ${tokens.spacer.x8} ${tokens.spacer.x2} ${tokens.spacer.x3};
`;

// Overridden icon with non-supported sizes
const TitleIcon = styled(Icon)`
  min-width: 22px;
  min-height: 22px;
  width: 22px;
  height: 22px;
`;

export interface ModalHeaderProps {
  /**
   * Styles override.
   */
  className?: string;
  /**
   * Subtitle text.
   */
  subtitle?: ReactNode;
  /**
   * Title text.
   */
  title: string;
  /**
   * Name of the icon to render next to title.
   */
  iconName: IconName;
}

export const ModalHeader = ({
  iconName,
  subtitle,
  title,
  className,
}: ModalHeaderProps): JSX.Element => (
  <Container className={className}>
    <span
      css={css`
        display: flex;
      `}
    >
      <TitleIcon
        icon={iconName}
        size="m"
        css={css`
          margin-right: ${tokens.spacer.x1};
        `}
      />
      <Text as="h1" textType="header5">
        {title}
      </Text>
    </span>
    {subtitle && (
      <Text
        as="p"
        textColor="text_light"
        textType="body2"
        css={css`
          margin: ${tokens.spacer.x0} 0 0 30px;
        `}
      >
        {subtitle}
      </Text>
    )}
  </Container>
);
